import { FC } from 'react';
import { FormGroup as FormGroupBase, FormLabel } from 'react-bootstrap';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import FormGroup from 'components/FormGroup';
import Phone, { PhoneProps } from 'components/forms/Phone';
import Telcodes from 'components/Telcodes';
import { EventParams } from 'types/common';
import { useTrack } from 'utils/track';

export interface TelcodesPhoneProps {
    $formutil: $Formutil<any>;
    label?: React.ReactNode;
    telcodeName?: string;
    defaultTelCode?: string;
    disabled?: boolean;
    eventParams?: {
        telCode?: EventParams;
        phone?: EventParams;
    };
    phoneOptions?: PhoneProps;
}

const TelcodesPhone: FC<TelcodesPhoneProps> = props => {
    const {
        label = __('Phone number'),
        telcodeName = 'tel_code',
        defaultTelCode,
        disabled,
        $formutil,
        eventParams,
        phoneOptions
    } = props;
    const labelNode = typeof label === 'string' ? <FormLabel>{label}</FormLabel> : label;
    const { telCode: telCodeEventParams, phone: phoneEventParams } = eventParams || {};
    const { name: phoneName = 'phone', ...restPhoneOptions } = phoneOptions || {};
    const { debounceTrackEvent, trackEvent } = useTrack();

    return (
        <FormGroupBase className="phone-root">
            {labelNode}
            <div className="d-flex">
                <FormGroup
                    name={telcodeName}
                    // 邮箱注册userInfo里面取到的telCode是空字符串
                    $defaultValue={defaultTelCode || '1'}
                    required={!disabled}
                    validMessage={{
                        required: __('Please Select')
                    }}
                    $onFieldChange={() => {
                        $formutil.$getField(phoneName!)!.$validate();

                        if (telCodeEventParams) {
                            trackEvent(telCodeEventParams);
                        }
                    }}
                    className={disabled ? undefined : 'flex-grow-1'}>
                    <Telcodes disabled={disabled} />
                </FormGroup>
                <Phone
                    name={phoneName}
                    disabled={disabled}
                    onChange={() => {
                        if (phoneEventParams) {
                            debounceTrackEvent(phoneEventParams);
                        }
                    }}
                    {...restPhoneOptions}
                />
            </div>
        </FormGroupBase>
    );
};

export default connect(TelcodesPhone);
